import React, { useState } from 'react'
import { ColumnDefinition } from 'common/components/DataTable'
import { DataTable } from 'common/components/DataTable'
import { usePaginatedFetch } from 'common/hooks/usePaginatedFetch'
import Title from 'common/components/Title'
import BigSpinner from 'common/components/BigSpinner'
import { Button } from 'react-bootstrap'
import API from 'common/logic/API'
import OperationWorkflowModal from 'common/components/OperationWorkflowModal'
import EditTagWorkflow from 'application/tags/EditTagWorkflow'
import * as Icon from 'react-bootstrap-icons'
import { Tag } from 'types'

function TagsList() {
    const [modal, setModal] = useState<{ type: string; id?: number; name?: string } | null>(null)
    const [refreshKey, setRefreshKey] = useState(0)
    const { results, error } = usePaginatedFetch<Tag>('/tags', undefined, refreshKey)

    const refreshData = () => setRefreshKey(k => k + 1)
    const hideDialogs = () => setModal(null)

    const columnDefinitions = [
        new ColumnDefinition<Tag>('Name', 'name'),
        new ColumnDefinition<Tag>('Actions', obj => <>
            <Button variant="link" title="Edit" onClick={() => setModal({ type: 'edit', id: obj.id, name: obj.name })}>
                <Icon.Pencil />
            </Button> |{' '}
            <Button variant="link" title="Delete" onClick={() => setModal({ type: 'delete', id: obj.id, name: obj.name })}>
                <Icon.Trash />
            </Button>
        </>)
    ]

    let modalEl: React.ReactNode = null
    if (modal) {
        const completion = (result: unknown) => { hideDialogs(); if (result) refreshData() }
        switch (modal.type) {
            case 'delete':
                modalEl = <OperationWorkflowModal
                    confirmationStep={() => `Delete tag "${modal.name}"? It will be removed from all movements.`}
                    executionStep={() => API.delete(`/tags/${modal.id}`).catch((err: any) => {
                        const label = err?.response?.data?.label
                        if (label === 'reference-violation-error') {
                            const entity: string | undefined = err?.response?.data?.stringFields?.entity
                            const entityLabel =
                                entity === 'classificationRules' ? 'classification rules' :
                                entity === 'expectedMovements' ? 'expected movements' :
                                'other records'
                            throw new Error(`"${modal.name}" cannot be deleted because it is still assigned to ${entityLabel}.`)
                        }
                        throw err
                    })}
                    completionCallback={completion}
                />
                break
            case 'create':
            case 'edit':
                modalEl = <EditTagWorkflow onSuccess={completion} entryId={modal.id} />
                break
            default:
        }
    }

    return <>
        <Title title="Tags" />
        {error && <p>Error loading tags.</p>}
        {results === null ? <BigSpinner /> : <>
            <Button variant="link" onClick={() => setModal({ type: 'create' })}>Add new tag</Button>
            <DataTable
                columns={columnDefinitions as unknown as ColumnDefinition[]}
                rows={results as unknown as Record<string, unknown>[]}
            />
        </>}
        {modalEl}
    </>
}

export default TagsList
